var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

var Checkbox = (_temp = _class = function (_Component) {
	_inherits(Checkbox, _Component);

	function Checkbox() {
		_classCallCheck(this, Checkbox);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Checkbox.prototype.render = function render() {
		var _props = this.props,
		    text = _props.text,
		    value = _props.value,
		    inline = _props.inline,
		    onChange = _props.onChange,
		    readOnly = _props.readOnly,
		    labelWidth = _props.labelWidth,
		    invalid = _props.invalid,
		    formValue = _props.formValue,
		    props = _objectWithoutProperties(_props, ['text', 'value', 'inline', 'onChange', 'readOnly', 'labelWidth', 'invalid', 'formValue']);

		return React.createElement(
			'label',
			{ className: classNames('control checkbox', { 'control-inline': inline, disabled: readOnly }) },
			React.createElement('input', _extends({}, props, {
				type: 'checkbox',
				checked: value,
				disabled: readOnly,
				onClick: function onClick(event) {
					return onChange(!value);
				},
				onChange: function onChange() {}
			})),
			React.createElement('span', { className: 'control-indicator' }),
			text && React.createElement(
				'span',
				{ className: 'control-label' },
				text
			)
		);
	};

	return Checkbox;
}(Component), _class.propTypes = {
	text: PropTypes.node,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
	onChange: PropTypes.func
}, _class.defaultProps = {
	value: false,
	onChange: function onChange() {
		return console.warn('No onChange provided for Checkbox');
	}
}, _temp);
export { Checkbox as default };